export const SOPTableData = [
    {
        task: "OSDMA/SRC",
        resource: "Revenue Disaster Management Department",
        description: "State",
    },
    {
        task: "Additional District Megistrate,anugul",
        resource: "Police Department",
        description: "Block/Sub Division",
    },
    {
        task: "ADH/Sonepur",
        resource: "Agriculture & Farmers Empowerment Department",
        description: "Block/Sub Division",
    },
];

export const sopcolumnsForExport = [
  { label: "Name", key: "name" },
  { label: "Description", key: "description" },
  { label: "Task List", key: "task_list" },
  { label: "Resource List", key: "resource_list" },
  {label: "Created On", key: "created_on"},
  {label: "Updated By", key: "updated_by"},
];
